import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { getTargetedSlug } from "../../selectors";
import { BaseVerticalCheck } from "./BaseVerticalCheck";

export const BaseTargetedVerticalCheck = ({ vertical, children }) => {
	const targetedSlug = useSelector(getTargetedSlug);
	if (targetedSlug == null) return null;

	return <BaseVerticalCheck vertical={vertical}>{children}</BaseVerticalCheck>;
};

BaseTargetedVerticalCheck.propTypes = {
	vertical: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
};
